import {normalizeActionHandler} from './normalizeActionHandler';
import {sandbox, locations} from '@servicenow/ui-internal';
import log from '../../log';

const {LIFECYCLE} = locations;
import {
	COMPONENT_CONNECTED,
	COMPONENT_DISCONNECTED,
	COMPONENT_BOOTSTRAPPED,
	COMPONENT_PROPERTY_CHANGED,
	PROPERTIES_SET_LIFECYCLE,
	ON_CONNECT_LIFECYCLE,
	ON_DISCONNECT_LIFECYCLE,
	ON_BOOTSTRAP_LIFECYCLE
} from '../../constants';
import getHostVariables from '../getHostVariables';
import {HELPERS_SCHEDULED} from '../../symbols';
import {wrapDispatch} from '../../actions/utils';

const lifeCycleFnsToHandlerMap = {
	[COMPONENT_CONNECTED]: {lifecycle: ON_CONNECT_LIFECYCLE, display: 'COMPONENT_CONNECTED'},
	[COMPONENT_DISCONNECTED]: {lifecycle: ON_DISCONNECT_LIFECYCLE, display: 'COMPONENT_DISCONNECTED'},
	[COMPONENT_BOOTSTRAPPED]: {lifecycle: ON_BOOTSTRAP_LIFECYCLE, display: 'COMPONENT_BOOTSTRAPPED'},
	[COMPONENT_PROPERTY_CHANGED]: {
		lifecycle: PROPERTIES_SET_LIFECYCLE,
		display: 'COMPONENT_PROPERTY_CHANGED'
	}
};

function createOnPropertyChangeHandler(config, def) {
	const {properties} = config;
	const onPropertiesSet = config[def.lifecycle];
	const fns = {};
	for (const k in properties) {
		const {onChange} = properties[k];
		if (typeof onChange === 'function') fns[k] = onChange;
	}

	if (!Object.keys(fns).length && !onPropertiesSet) return;

	return function onPropertyChange({
		dispatch,
		action: {
			payload: {host, name, previousValue, value}
		}
	}) {
		const hostVariables = getHostVariables(host);

		if (onPropertiesSet) {
			sandbox(onPropertiesSet, {
				args: [host, hostVariables[HELPERS_SCHEDULED]],
				dispatch,
				host,
				location: LIFECYCLE,
				details: {name: def.lifecycle},
				log
			});
		}

		const fn = fns[name];
		if (fn) {
			sandbox(fn, {
				args: [value, previousValue, hostVariables[HELPERS_SCHEDULED]],
				dispatch,
				host,
				location: LIFECYCLE,
				details: {name: def.lifecycle},
				log
			});
		}
	};
}

export function lifeCycleFnsToHandlers(configs, tagName) {
	const actionHandlers = {};
	for (const k in lifeCycleFnsToHandlerMap) {
		const def = lifeCycleFnsToHandlerMap[k];
		const {length: configsCount} = configs;
		const actionType = k;
		actionHandlers[actionType] = [];

		for (let i = 0; i < configsCount; i++) {
			const config = configs[i];
			if (actionType === COMPONENT_PROPERTY_CHANGED) {
				const onPropertyChangeEffect = createOnPropertyChangeHandler(config, def);
				if (onPropertyChangeEffect) {
					actionHandlers[actionType].push(
						normalizeActionHandler(
							{
								effect: onPropertyChangeEffect,
								type: 'effect'
							},
							tagName
						)
					);
				}
			} else {
				const fn = config[def.lifecycle];
				if (typeof fn === 'function') {
					actionHandlers[actionType].push(
						normalizeActionHandler(
							{
								effect({
									dispatch,
									action,
									action: {
										payload: {host}
									}
								}) {
									const wrappedDispatch = wrapDispatch(host, action);
									const helpers = wrappedDispatch.dispatch;
									Object.assign(helpers, wrappedDispatch);

									sandbox(fn, {
										args: config.options ? [host, helpers, config.options] : [host, helpers],
										dispatch,
										host,
										location: LIFECYCLE,
										details: {name: def.lifecycle},
										log
									});
								},
								type: 'effect'
							},
							tagName
						)
					);
				}
			}
		}
	}

	return actionHandlers;
}
